import { Component } from '@angular/core';

/**
 * Shell compartilhado das telas de auth (login, recuperar/trocar senha, convites).
 * Fundo aurora suave + card centralizado com barra de marca no topo. O conteúdo
 * (logo, título, form, botões, links) entra via <ng-content>. NÃO é usado no wizard.
 */
@Component({
    selector: 'auth-card-layout',
    templateUrl: 'auth-card-layout.component.html',
    styleUrl: 'auth-card-layout.component.scss',
    standalone: true,
})
export class AuthCardLayoutComponent {}
